import { render, staticRenderFns } from "./cookie-notice.vue?vue&type=template&id=40b22b30&scoped=true"
import script from "./cookie-notice.vue?vue&type=script&lang=js"
export * from "./cookie-notice.vue?vue&type=script&lang=js"
import style0 from "./cookie-notice.vue?vue&type=style&index=0&id=40b22b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b22b30",
  null
  
)

export default component.exports